/**
 * Canonical lifecycle helpers for list/admin views (PR6).
 * Map modules may import these; undefined flags = eligible (legacy rows).
 */

export function isRecordDeleted (record) {
  return record?.isDeleted === true
}

/** Any explicit false on operational flags hides the record. */
export function isRecordOperationallyActive (record) {
  if (!record) return false
  if (isRecordDeleted(record)) return false
  if (record.isActive === false) return false
  if (record.enabled === false) return false
  if (record.active === false) return false
  return true
}

/** Mobile device login eligibility (post-PR3 API semantics). */
export function isDeviceLoginActive (device) {
  if (!device) return false
  if (isRecordDeleted(device)) return false
  return device.isActive === true && device.enabled !== false
}

export function isDeviceSoftDeleted (device) {
  return isRecordDeleted(device)
}

/** Legacy users tab: active && !deleted. */
export function isUserOperationallyActive (user) {
  if (!user) return false
  if (isRecordDeleted(user)) return false
  if (user.isActive === false || user.active === false) return false
  return true
}

/** Inline toggle/delete controls (legacy: hidden when deleted). */
export function canToggleLifecycleRecord (record, { currentUserId } = {}) {
  if (!record || isRecordDeleted(record)) return false
  if (currentUserId != null && String(record.id) === String(currentUserId)) return false
  return true
}
